module.exports = __webpack_public_path__ + "img/logo_aldeia_girassois.9f1765fb.png";